import type { AssetContainerTypes } from 'js/src/client';
import { SourceEnum } from 'js/src/client';
import { PREMIUM_SOURCES } from 'js/src/libs/video-data-consts';

export enum PREMIUM_LEVEL {
    UPGRADE_FOR_UNLIMITED = 'upgrade-unlimited',
    UPGRADE_FOR_MARKETPLACE = 'upgrade-marketplace',
    MARKETPLACE = 'marketplace',
    INCLUDED_WITH_SUBSCRIPTION = 'included',
    FREE = 'free',
    NONE = 'none',
}

class PremiumMediaChecker {
    static badge_required_for_source(
        source: SourceEnum,
        assetType: AssetContainerTypes,
    ): PREMIUM_LEVEL {
        // depending on the source type and the user, return a PREMIUM_LEVEL
        // if user upload, don't show a badge
        if (
            source === SourceEnum.SOURCE_ARTICLE ||
            source === SourceEnum.SOURCE_USER ||
            source === SourceEnum.SOURCE_USER_WATERMARK ||
            source === SourceEnum.SOURCE_USER_OUTRO
        ) {
            return PREMIUM_LEVEL.NONE;
        }
        // if not premium, show free badge
        if (!PREMIUM_SOURCES.has(source)) {
            return PREMIUM_LEVEL.FREE;
        }

        // check if user can use source
        const {
            getty_media,
            getty_unlimited_media,
            shutterstock_media,
            shutterstock_unlimited_media,
        } = SERVER.USER?.capabilities ?? {};

        switch (source) {
            case SourceEnum.SOURCE_GETTY: {
                if (getty_media) {
                    return PREMIUM_LEVEL.MARKETPLACE;
                }
                return PREMIUM_LEVEL.UPGRADE_FOR_MARKETPLACE;
            }
            case SourceEnum.SOURCE_SHUTTERSTOCK_EDITORIAL: {
                if (shutterstock_media) {
                    return PREMIUM_LEVEL.MARKETPLACE;
                }
                return PREMIUM_LEVEL.UPGRADE_FOR_MARKETPLACE;
            }
            case SourceEnum.SOURCE_SHUTTERSTOCK_PREMIUM: {
                if (shutterstock_media) {
                    return PREMIUM_LEVEL.MARKETPLACE;
                }
                return PREMIUM_LEVEL.UPGRADE_FOR_MARKETPLACE;
            }
            default:
                if (
                    source === SourceEnum.SOURCE_SHUTTERSTOCK_ESSENTIALS &&
                    shutterstock_unlimited_media
                ) {
                    return PREMIUM_LEVEL.INCLUDED_WITH_SUBSCRIPTION;
                } else if (
                    source === SourceEnum.SOURCE_SHUTTERSTOCK_CHOICES &&
                    shutterstock_unlimited_media
                ) {
                    return PREMIUM_LEVEL.INCLUDED_WITH_SUBSCRIPTION;
                } else if (source === SourceEnum.SOURCE_GETTY_UNLIMITED && getty_unlimited_media) {
                    return PREMIUM_LEVEL.INCLUDED_WITH_SUBSCRIPTION;
                } else if (
                    source === SourceEnum.SOURCE_SHUTTERSTOCK_UNLIMITED &&
                    shutterstock_unlimited_media
                ) {
                    return PREMIUM_LEVEL.INCLUDED_WITH_SUBSCRIPTION;
                } else {
                    return PREMIUM_LEVEL.UPGRADE_FOR_UNLIMITED;
                }
        }
    }
}

export default PremiumMediaChecker;
